import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { licenseTrackerEnvironment } from '../license-tracker-environment';

/**
 * Requests a report of licenses expiring before a certain end date and time,
 * and sends it to certain emails
 * @param endTime The end time of the request
 * @param recipients The recipients of the request
 * @returns An object indicating success
 */
export function postExpirationmetricsAccountsReport(
  this: unknown,
  endTime: Date,
  recipients: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        licenseTrackerEnvironment.resolve(
          this
        ).expirationmetricsAccountsReportUrl,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            endTime: endTime.toISOString(),
            recipients,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        receipt: z.string(),
      })
    )
  );
}
